import {useState} from 'react'
import { NavLink } from "react-router-dom";
// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import PieActiveArc from "components/PieChart/PieChart"

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Card from "@mui/material/Card"
import PersonalDataCharts from "./personalDataCharts/PersonalDataCharts"
import { overAllExperienceData, positiveExperienceAvatars, regularExperienceAvatars, negativeExperienceAvatars } from './data/shop_overallExperience';
import { productSatisfactionData, yesAvatars, notSureAvatars, noAvatars } from './data/shop_productSatisfaction';
import { serviceAndAssistanceData, greatServiceAvatars, regularServiceAvatars, notSoGreatAvatars } from './data/shop_service_and_assistance';
import { useMaterialUIController, setLayout } from "context";
import MDTypography from "components/MDTypography";
import MDAvatar from 'components/MDAvatar';
import Tooltip from "@mui/material/Tooltip";

import team1 from "assets/images/team-1.jpg"
import team2 from "assets/images/team-2.jpg"
import team3 from "assets/images/team-3.jpg"
import team4 from "assets/images/team-4.jpg"
import team5 from "assets/images/team-5.jpg"

/* eslint-disable react/prop-types */



function ShopReport() {
  const [showOverallExperienceAvatars, setShowOverallExperienceAvatars] = useState(null)
  const [experience, setExperience] = useState("")

  const [showProductSatisfactionAvatars, setShowProductSatisfactionAvatars] = useState(null)
  const [productSatisfaction, setProductSatisfaction] = useState("")

  const [showServiceAndAssistance, setShowServiceAndAssistance] = useState(null)
  const [serviceAndAssistance, setServiceAndAssitance] = useState("")

  function onOverAllExperiencePressed(id){
      if (id == 0){
        setShowOverallExperienceAvatars(positiveExperienceAvatars)
        setExperience("positive")
      }
      if(id == 1){
        setShowOverallExperienceAvatars(regularExperienceAvatars)
        setExperience("regular")
      }
      if(id == 2) {
        setShowOverallExperienceAvatars(negativeExperienceAvatars)
        setExperience("negative")
      }
  }

  function onProductSatisfactionPressed(id){
    if (id == 0){
      setShowProductSatisfactionAvatars(yesAvatars)
      setProductSatisfaction("Yes")
    }
    if(id == 1){
      setShowProductSatisfactionAvatars(notSureAvatars)
      setProductSatisfaction("Not sure")
    }
    if(id == 2) {
      setShowProductSatisfactionAvatars(noAvatars)
      setProductSatisfaction("No")
    }
  }

    function onServiceAndAssistancePresssed(id){
      if (id == 0){
        setShowServiceAndAssistance(greatServiceAvatars)
        setServiceAndAssitance("Great service")
      }
      if(id == 1){
        setShowServiceAndAssistance(regularServiceAvatars)
        setServiceAndAssitance("regular service")
      }
      if(id == 2) {
        setShowServiceAndAssistance(notSoGreatAvatars)
        setServiceAndAssitance("not so great service")
      }
    }

  const participants = [{name: "ElenaShadow", image:team1}, {name: "AlexPhoenix", image:team2}, {name: "EmilyJhonson", image:team3}, {name:"ChrisTaylor", image:team4}, {name:"LaraAdventure", image:team5}]

  const renderParticipants = participants.map((participant) => (
    <Tooltip key={participant.name} title={participant.name} placement="bottom">
      <MDAvatar
        src={participant.image}
        alt={participant.name}
        size="lg"
        sx={({ borders: { borderWidth }, palette: { white } }) => ({
          border: `${borderWidth[2]} solid #F2EFF8`,
          cursor: "pointer",
          position: "relative",
          ml: -1.25,

          "&:hover, &:focus": {
            zIndex: "10",
          },
          
        })}
      />
    </Tooltip>
  ));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
          <Card sx={{ height: "100%" }}>
            <MDBox pt={3} pb={2} px={2}>
              <MDBox
                component="ul"
                display="flex"
                flexDirection="column"
                p={0}
                m={0}
                sx={{ listStyle: "none" }}
              >
              <MDTypography variant="h5" fontWeight="medium" gutterBottom>
                Shop survey report
              </MDTypography>
              <MDBox>
                <Card sx={{ mt:2, padding: "2rem", backgroundColor: "#F8F9FA" }}>
                  <MDBox display="flex" justifyContent="space-between">
                    <MDBox display="block" justifyContent="center" alignItems="center" width={"45%"}>
                      <MDTypography variant="h6" fontWeight="bold" gutterBottom sx={{marginTop:"1rem"}}>
                        Overall experience
                      </MDTypography>
                      <PieActiveArc onClickId={onOverAllExperiencePressed} data={overAllExperienceData} legendHidden={false}/>
                    </MDBox>
                    <MDBox width={"55%"}>
                      {showOverallExperienceAvatars && 
                        <PersonalDataCharts data={showOverallExperienceAvatars} title={"Avatars with " + experience + " experience"}/>
                      }
                    </MDBox>
                  </MDBox>
                </Card>
              </MDBox>
              <MDBox mt={3}>
                <Card sx={{ padding: "2rem", backgroundColor: "#F8F9FA"}}>
                  <MDBox display="flex" justifyContent="space-between">
                    <MDBox display="block" justifyContent="center" width={"45%"}>
                      <MDTypography variant="h6" fontWeight="bold" gutterBottom sx={{marginTop:"1rem"}}>
                        Product satisfaction
                      </MDTypography>
                      <PieActiveArc onClickId={onProductSatisfactionPressed} data={productSatisfactionData} legendHidden={false}/>
                    </MDBox>
                    <MDBox width={"55%"}>
                      {showProductSatisfactionAvatars && 
                        <PersonalDataCharts data={showProductSatisfactionAvatars} title={"Customer satisfaction answer: " + productSatisfaction}/>
                      }
                    </MDBox>
                  </MDBox>
                </Card>
              </MDBox>
              <MDBox mt={3}>
                <Card sx={{ padding: "2rem", backgroundColor: "#F8F9FA"}}>
                  <MDBox display="flex" justifyContent="space-between">
                    <MDBox display="block" justifyContent="center" width={"45%"}>
                      <MDTypography variant="h6" fontWeight="bold" gutterBottom sx={{marginTop:"1rem"}}>
                        Service and assistance
                      </MDTypography>
                      <PieActiveArc onClickId={onServiceAndAssistancePresssed} data={serviceAndAssistanceData} legendHidden={false}/>
                    </MDBox>
                    <MDBox width={"55%"}>
                      {showServiceAndAssistance && 
                        <PersonalDataCharts data={showServiceAndAssistance} title={"Avatars that voted " + serviceAndAssistance}/>
                      }
                    </MDBox>
                  </MDBox>
                </Card>
              </MDBox>
              <MDBox mt={3}>
                  <MDBox display="flex" justifyContent="space-between" p={"2rem"}>
                    <MDBox display="block" justifyContent="center" width={"45%"}>
                      <MDTypography variant="h6" fontWeight="bold" gutterBottom sx={{marginTop:"1rem", marginBottom: "1rem"}}>
                        Avatars that took part in this campaign
                      </MDTypography>
                      <MDBox display="flex">{renderParticipants}</MDBox>
                    </MDBox>
                  </MDBox>
              </MDBox>
            </MDBox>
            </MDBox>
          </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ShopReport;
